import { render } from "./ReportItem.vue?vue&type=template&id=6aa63594&scoped=true"
import script from "./ReportItem.vue?vue&type=script&lang=js"
export * from "./ReportItem.vue?vue&type=script&lang=js"

import "./ReportItem.vue?vue&type=style&index=0&id=6aa63594&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src587305002/src/goku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa63594"]])

export default __exports__